import { RefreshCw, Loader2 } from 'lucide-react'
import { RewriteChannel } from '@/services/api'
import clsx from 'clsx'

interface ChannelTabsProps {
  channels: RewriteChannel[]
  selectedChannels: string[]
  activeChannelId: string | null
  isGenerating: boolean
  onSelectChannel: (channelId: string) => void
  onGenerate: () => void
}

export function ChannelTabs({
  channels, selectedChannels, activeChannelId, isGenerating,
  onSelectChannel, onGenerate,
}: ChannelTabsProps) {
  const activeChannels = channels.filter(c => selectedChannels.includes(c.id))

  if (activeChannels.length === 0) {
    return (
      <div className="px-4 py-3 border-b border-border-subtle bg-bg-secondary/30 text-center text-sm text-text-tertiary">
        채널을 선택하세요 (원문 등록 → 채널 선택)
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1 px-4 py-2 border-b border-border-subtle bg-bg-secondary/30 overflow-x-auto">
      {activeChannels.map(ch => {
        const icon = ch.icon === 'LayoutGrid' ? '📢' : '📝'
        return (
          <button
            key={ch.id}
            onClick={() => onSelectChannel(ch.id)}
            className={clsx(
              'px-3 py-1.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap flex items-center gap-1.5',
              activeChannelId === ch.id
                ? 'bg-primary text-white shadow-sm'
                : 'text-text-secondary hover:text-text-primary hover:bg-bg-elevated'
            )}
          >
            <span>{icon}</span>
            {ch.name}
          </button>
        )
      })}
      <div className="ml-auto flex-shrink-0">
        <button
          onClick={onGenerate}
          disabled={isGenerating || selectedChannels.length === 0}
          className="px-3 py-1.5 rounded-lg text-sm font-medium bg-primary/10 text-primary hover:bg-primary/20 disabled:opacity-50 flex items-center gap-1.5 transition-all"
        >
          {isGenerating ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
          생성
        </button>
      </div>
    </div>
  )
}
